"use strict"

import React from "react"
import SingleColumnForm, { SingleColumnConfirmationBody } from "../../widgets/SingleColumnForm"
import { getFormReducer } from "../../widgets/utils"

const initialState = {
  isLoading: false,
  name: "",
  description: "",
}

const initialWarningState = {
  nameWarn: false,
  descriptionWarn: false,
}

const formReducer = getFormReducer(initialState, initialWarningState)

export default function AddSourceModal(props) {
  const resources = [
    { label: "general.name", field: "name", type: "text" },
    { label: "general.description", field: "description", type: "textarea" },
  ]

  return (
    <SingleColumnForm
      formReducer={formReducer}
      initialState={initialState}
      initialWarningState={initialWarningState}
      resources={resources}
      ModalBody={SingleColumnConfirmationBody}
      confirmation_title={props.page_translation_id}
      label={"Add New Source"}
      {...props}
    />
  )
}
